var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "icon-container", class: _vm.containerClasses },
    [
      _c(
        "span",
        {
          class: _vm.classNames,
          attrs: { tabindex: _vm.isTabbable, "aria-label": _vm.ariaLabel },
          on: {
            click: _vm.emitClick,
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.emitClick($event)
            }
          }
        },
        [
          !_vm.isCustom
            ? _c("font-awesome-icon", {
                class: _vm.style(_vm.type),
                attrs: {
                  icon: _vm.setIcon(_vm.icon),
                  "aria-label": _vm.icon + " icon",
                  alt: _vm.icon + " icon",
                  size: _vm.resolveSize(_vm.size)
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isCustom
            ? _c(
                "svg-icon",
                {
                  attrs: {
                    classNames: _vm.style(_vm.type),
                    Icon: _vm.setIcon(_vm.icon),
                    size: _vm.size,
                    editStroke: _vm.editStroke,
                    name: _vm.icon,
                    fill: _vm.fill
                  }
                },
                [_vm._t("default")],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("label")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b69f5ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b69f5ce","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseIcon.vue
// module id = null
// module chunks = 